import {
  LearnerProfile,
  LearnerProfileRepository,
} from '@/domain/precon-supporter';

/**
 * 受講者プロフィール取得ユースケース
 */
export class GetLearnerProfileUseCase {
  constructor(private readonly repository: LearnerProfileRepository) {}

  /**
   * 受講者プロフィールを取得
   * 存在しない場合は新規作成して返す
   */
  async execute(): Promise<LearnerProfile> {
    const profile = await this.repository.find();

    if (profile) {
      return profile;
    }

    // プロフィールが存在しない場合は新規作成
    const newProfile = LearnerProfile.create();
    await this.repository.save(newProfile);

    return newProfile;
  }
}
